// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { searchHistoryStyles } from "@stoneage/Overrides/Widgets/Header/SearchHistory";
import { color, styledScrollbar, xScreen } from "@stoneage/XDL/Utilities";
import Clock from "@insite/mobius/Icons/Clock";
import { css } from "styled-components";
import { fontConfig } from "@stoneage/XDL/constants";

searchHistoryStyles.wrapper = {
    css: css`
        display: flex;
        flex-direction: column;
        row-gap: 8px;
        padding: 12px;
        width: 100%;

        max-height: calc(100vh - 62px);
        overflow: auto;
        ${styledScrollbar(4)}

        ${xScreen("lte", "md")} {
            max-height: calc(100vh - 168px);
            padding: 16px;
        }
        ${xScreen("lt", "sm")} {
            padding: 0 12px 12px;
        }
    `,
};

searchHistoryStyles.headerText = {
    variant: "h5",
    forwardAs: "p",
    css: css`
        margin-bottom: 0;
    `,
};

searchHistoryStyles.clearLink = {
    typographyProps: {
        ...fontConfig.xSmallSingleLine,
    },
};

searchHistoryStyles.topWrapper = {
    css: css`
        display: flex;
        justify-content: space-between;
        align-items: center;
        gap: 16px;
    `,
};

searchHistoryStyles.icon = {
    src: Clock,
    size: 12,
    color: "primary",
    css: css`
        margin-right: 6px;
    `,
};

searchHistoryStyles.link = {
    color: "text",
    typographyProps: {
        ...fontConfig.xSmallSingleLine,
    },
};

searchHistoryStyles.itemsWrapper = {
    css: css`
        display: flex;
        flex-direction: column;
        row-gap: 12px;
    `,
};
